import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useApp } from "../store";
import useDocumentMeta from "../hooks/useDocumentMeta";
import { ArrowRight } from "lucide-react";

export default function Blog() {
  const { API } = useApp();
  const [articles, setArticles] = useState([]);

  useDocumentMeta({
    title: "Journal — Perfumery, Attars, and Kannauj Craft",
    description: "Long-reads on natural perfumery, traditional Kannauj attars, GC/MS authentication, sourcing guides, and the craft behind every absolute.",
  });

  useEffect(() => {
    axios.get(`${API}/articles`).then(r => setArticles(r.data || []));
  }, [API]);

  return (
    <div className="pt-32 pb-24 px-6 md:px-12 max-w-[1400px] mx-auto" data-testid="blog-page">
      <div className="max-w-3xl mb-20">
        <div className="overline text-copper mb-4">Journal</div>
        <h1 className="font-serif-display text-5xl md:text-7xl leading-none mb-6">Notes on rare<br /><span className="italic text-[#8A8D8A]">aromatics.</span></h1>
        <p className="text-base text-[#5C5E5C] leading-relaxed">
          Long-reads on natural perfumery, traditional Kannauj attars, sourcing guides,
          and the craft behind every absolute we ship.
        </p>
      </div>

      {articles.length === 0 ? (
        <p className="text-[#8A8D8A] font-serif-display text-2xl italic">No articles yet.</p>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-12" data-testid="article-grid">
          {articles.map(a => (
            <Link
              key={a.id}
              to={`/blog/${a.slug}`}
              className="group block"
              data-testid={`article-card-${a.slug}`}
            >
              {a.cover_image_url ? (
                <div className="aspect-[5/3] bg-clay overflow-hidden mb-6">
                  <img src={a.cover_image_url} alt={a.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
              ) : (
                <div className="aspect-[5/3] bg-gradient-to-br from-[#EBE4D8] via-[#F3EFE9] to-[#FAF8F2] mb-6 flex items-center justify-center">
                  <span className="font-serif-display text-5xl text-[#C9BBA0] italic">{a.title.slice(0, 1)}</span>
                </div>
              )}
              <div className="flex flex-wrap gap-2 mb-3">
                {(a.tags || []).slice(0, 2).map(t => (
                  <span key={t} className="overline text-[10px] text-copper">{t}</span>
                ))}
              </div>
              <h2 className="font-serif-display text-2xl leading-tight mb-3 group-hover:text-copper transition-colors">{a.title}</h2>
              <p className="text-sm text-[#5C5E5C] leading-relaxed mb-4 line-clamp-3">{a.excerpt}</p>
              <span className="overline text-[10px] inline-flex items-center gap-2 text-[#1E1F1E]">Read article <ArrowRight size={11} /></span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
